// The health feature's registrations: its navigation entry (the first user of the registry).
import { ActivityIcon } from "lucide-react";
import { registerNav } from "../../app/registry/nav";

registerNav({
  id: "health",
  group: "monitor",
  labelKey: "health.nav",
  icon: ActivityIcon,
  to: "/health",
  order: 10,
});

export { useHealth } from "./use-health";
